import * as React from 'react'

export interface PictureProps {
  sources: {
    sourceSet: string
    type?: string | null
    media?: string | null
  }[]
  default: string
  alt: string
  lazy?: boolean
  width?: string
  aspectRatio?: string
  className?: string
  style?: React.CSSProperties
  fetchPriority?: 'high' | 'low' | 'auto'
}

export const Picture: React.FunctionComponent<PictureProps> = (props) => {
  return (
    <picture>
      {props.sources.map((source) => (
        <source
          srcSet={source.sourceSet}
          media={source.media || undefined}
          type={source.type || undefined}
        />
      ))}
      <img
        src={props.default}
        alt={props.alt}
        loading={props.lazy ? 'lazy' : 'eager'}
        style={{
          aspectRatio: props.aspectRatio,
          ...(props.style || {}),
        }}
        className={props.className}
        // @ts-ignore
        fetchpriority={props.fetchPriority || 'auto'}
      />
    </picture>
  )
}
